import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../../context/ThemeContext';
import { HeaderProps } from './types';
import { LABELS } from './constants';
import {
  HeaderContainer,
  TitleContainer,
  Title,
  Subtitle,
  AddButton,
} from './styles';

const Header: React.FC<HeaderProps> = ({ onAddDevice }) => {
  const { isDarkMode } = useTheme();

  return (
    <HeaderContainer>
      <TitleContainer>
        <Title $isDark={isDarkMode}>{LABELS.PAGE_TITLE}</Title>
        <Subtitle $isDark={isDarkMode}>{LABELS.PAGE_SUBTITLE}</Subtitle>
      </TitleContainer>
      <AddButton
        type="primary"
        icon={<FontAwesomeIcon icon={faPlus} />}
        onClick={onAddDevice}
        size="large"
      >
        {LABELS.ADD_DEVICE}
      </AddButton>
    </HeaderContainer>
  );
};

export default Header;
